var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_603",
    "data-name": "Groupe 603",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.756,
    height: 42.246,
    viewBox: "0 0 30.756 42.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_532",
    "data-name": "Trac\\xE9 532",
    d: "M0-16.7H30.756V-58.948H0Z",
    transform: "translate(0 58.948)",
    fill: "#e30613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_602",
    "data-name": "Groupe 602",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_601",
    "data-name": "Groupe 601",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_531",
    "data-name": "Trac\\xE9 531",
    d: "M-9.9-13.787H-27.45c15.664-9.6,22.581-16.293,22.581-23.781,0-7.032-5.546-11.09-14.75-11.09a41.675,41.675,0,0,0-13.834,2.572v10.233h.457l8.118-11.2A12.175,12.175,0,0,1-21.5-47.63c4.4,0,6.631,3.831,6.631,9.375,0,8.747-5.2,16.521-20.065,31.041v.8H-4.182v-13.72H-4.64Z",
    transform: "translate(34.938 48.658)",
    fill: "#e30613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.83bf087062f951408719a19336a51eb4.svg";
export { ForwardRef as ReactComponent };